import { useContext } from 'react';
import { AlteracaoNcmEmLoteContextData } from '../types/context';
import { AlteracaoNcmEmLoteContext } from '../contexts/AlteracaoNcmEmLoteContext';

export const useAlteracaoNcmLote = (): AlteracaoNcmEmLoteContextData => {
  const ctx = useContext(AlteracaoNcmEmLoteContext);
  if (!ctx) {
    throw new Error(
      'useAlteracaoNcmLote deve ser usado dentro de AlteracaoNcmEmLoteProvider.',
    );
  }
  return ctx;
};
